import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { useCounters } from "../../hooks/useCounters";

type LayoutProps = {
  children: React.ReactNode;
  chrome?: boolean;
};

export default function Layout({ children, chrome = true }: LayoutProps) {
  const { pathname } = useLocation();

  useScrollReveal();
  useCounters();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return (
    <>
      {chrome && <Navbar />}
      <main>{children}</main>
      {chrome && <Footer />}
    </>
  );
}
